import { Alert, Box, Chip, Typography } from "@mui/material";
import {
	BooleanField,
	DateField,
	DeleteButton,
	EditButton,
	EmailField,
	ImageField,
	Show,
	SimpleShowLayout,
	TextField,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";
import { BanButton } from "./BanButton";
import { RoleField } from "./RoleField";

const UserShowActions = () => {
	const record = useRecordContext();

	return (
		<TopToolbar>
			<BanButton />
			<EditButton />
			{record?.deletedAt ? (
				<RestoreButton resource="users" />
			) : (
				<DeleteButton />
			)}
		</TopToolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This user was deleted on {new Date(record.deletedAt).toLocaleDateString()}
			.
		</Alert>
	);
};

const BannedAlert = () => {
	const record = useRecordContext();
	if (!record?.banned) return null;

	return (
		<Alert severity="error" sx={{ mb: 2 }}>
			<Typography variant="subtitle2">User is banned</Typography>
			{record.banReason && (
				<Typography variant="body2">Reason: {record.banReason}</Typography>
			)}
			{record.banExpires && (
				<Typography variant="body2">
					Expires: {new Date(record.banExpires).toLocaleString()}
				</Typography>
			)}
		</Alert>
	);
};

const StatusField = () => {
	const record = useRecordContext();
	if (!record) return null;

	return (
		<Box sx={{ display: "flex", gap: 1 }}>
			{record.banned && <Chip label="Banned" color="error" size="small" />}
			{record.emailVerified ? (
				<Chip label="Verified" color="success" size="small" />
			) : (
				<Chip label="Unverified" color="warning" size="small" />
			)}
		</Box>
	);
};

export const UserShow = () => (
	<Show actions={<UserShowActions />}>
		<DeletedAlert />
		<BannedAlert />
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="name" />
			<EmailField source="email" />
			<ImageField source="image" label="Avatar" emptyText="No avatar" />
			<RoleField />
			<StatusField />
			<BooleanField source="emailVerified" label="Email Verified" />
			<BooleanField source="banned" />
			<TextField source="banReason" label="Ban Reason" emptyText="-" />
			<DateField
				source="banExpires"
				label="Ban Expires"
				showTime
				emptyText="-"
			/>
			<TextField
				source="stripeCustomerId"
				label="Stripe Customer ID"
				emptyText="-"
			/>
			<DateField source="createdAt" label="Created" showTime />
			<DateField source="updatedAt" label="Updated" showTime />
			<DateField source="deletedAt" label="Deleted" showTime emptyText="-" />
		</SimpleShowLayout>
	</Show>
);
